import React, { FC } from 'react';
import cx from 'clsx';

import styles from './MenuSection.module.scss';

type MenuSectionProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: string;
  titleTestId?: string;
  shimmer?: boolean;
}

export const MenuSection : FC<MenuSectionProps> = ({ title, titleTestId, children, shimmer, className, ...props }) => (
  <div {...props} className={cx(styles.section, className)}>
    {(title || shimmer) && <h2 data-testid={titleTestId} aria-hidden={shimmer} className={cx(styles.header, { shimmer })}>
      {!shimmer ? title : ''}
    </h2>}
    <div className={styles.items}>
      {children}
    </div>
  </div>
);
